import { settingsStringParsing } from '@orbital/games-frontend-library'
import { defaultSettingsReceive } from './defaultSettings'
export const helperReceiveSettings = (
  str: string,
  setStakes: any,
  setaudio: any,
) => {

  // console.log({ str })
  const [ante, AAbonus, sound, music, volume] = settingsStringParsing(
    str,
    defaultSettingsReceive,
  )
  // console.log([ante, AAbonus, music, sound, volume])
  setStakes({ ante, AAbonus })
  setaudio({ music, sound, volume })
}
